/**
 *
 * @param {Object} payload
 * @param {'submitted-form' | 'asset-resource' | 'asset-photo' | 'crm-photo' | 'task-resource' | 'lead-resource' | 'resource' | 'invoice-resource' | 'attachment-resource' | 'job-resource' | 'location-resource'} payload.uploadType
 * @param {number} [payload.resourceID=0] - The resource ID.
 */

const createResourceUploadParams = ({resourceID = 0, uploadType = 'resource'}) => ({
    resourceID,
    uploadType,
    newResource: !resourceID
});

const createJobUploadParams = ({jobID = 0, resourceID = 0}) => ({
    ...createResourceUploadParams({resourceID, uploadType: 'job-resource'}),
    jobID,
});

/**
 * @param {Object} payload
 * @param {'asset-resource' | 'asset-photo'} payload.uploadType
 * @param {any} payload.assetID
 * @param {any} payload.resourceID
 */
const createAssetUploadParams = ({
    assetID = 0, resourceID = 0, uploadType = 'asset-resource',
}) => ({
    ...createResourceUploadParams({resourceID, uploadType}),
    assetID,
});

const createLocationUploadParams = ({
                                     locationID = 0, resourceID = 0, uploadType = 'location-resource',
                                 }) => ({
    ...createResourceUploadParams({resourceID, uploadType}),
    locationID,
});

const createInvoiceUploadParams = ({
    invoiceID = 0, resourceID = 0,
}) => ({
    ...createResourceUploadParams({resourceID, uploadType: 'invoice-resource'}),
    invoiceID,
});

const createTaskUploadParams = ({
    taskID = 0, resourceID = 0,
}) => ({
    ...createResourceUploadParams({resourceID, uploadType: 'task-resource'}),
    taskID,
});

const createLeadUploadParams = ({
    leadID = 0, resourceID = 0,
}) => ({
    ...createResourceUploadParams({resourceID, uploadType: 'lead-resource'}),
    leadID,
});

const createSubmittedFormPhotoUploadParams = ({
    formID = 0,
    hash
}) => ({
    uploadType: "submitted-form",
    hash,
    options: {
        formID
    }
})

const createCRMPhotoUploadParams = ({
    resourceID = 0,
    resourceType = '5',
    crmID = 0,
}) => ({
    ...createResourceUploadParams({resourceID, uploadType: 'crm-photo'}),
    crmID,
    resourceType
})

const createSubmittedFormResourceUploadParams = ({
    resourceID = 0,
    sfID = 0
}) => ({
    ...createResourceUploadParams({resourceID, uploadType: 'submitted-form-resource'}),
    sfID,
})


export { createResourceUploadParams, createJobUploadParams, createAssetUploadParams, createInvoiceUploadParams, createTaskUploadParams, createLeadUploadParams, createLocationUploadParams, createSubmittedFormPhotoUploadParams, createSubmittedFormResourceUploadParams, createCRMPhotoUploadParams };